<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Creazione nuovo suggerimento
  </span>
  <ng-template #editHeader>
    Modifica suggerimento {{data.humanIdentifier}}
  </ng-template>
</h4>
<form *ngIf="form" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">

  <mat-form-field>
    <mat-label>Campo</mat-label>
    <mat-select formControlName="campo">
      <mat-option [value]="campo" *ngFor="let campo of campi">
        {{campo}}
      </mat-option>

    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Titolo</mat-label>
    <input matInput formControlName="titolo">
  </mat-form-field>
  <mat-form-field>

    <mat-label>
      Testo
    </mat-label>
    <input matInput formControlName="testo">
  </mat-form-field>

  <mat-form-field>
    <mat-label>
      Ordinale
    </mat-label>
    <input matInput formControlName="ordinale" type="number">
  </mat-form-field>

</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>